import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Header from '../../components/Header/Header';
import translate from '../../libs/i18n';
import Api from '../../libs/Api';

import { VersionStyle } from './VersionStyle';
import { use } from 'react';

const Version = () => {
  const language = useSelector((state) => state.settings.language);

  const [versions, setVersions] = useState([]);

  useEffect(() => {
    const fetchVersions = async () => {
      try {
        const response = await Api.getVersion();
        if (response.status === 200) {
          setVersions(response.data);
        } else {
          console.error('Erro ao buscar versões:', response);
        }
      } catch (error) {
        console.error('Erro ao buscar versões:', error);
      }
    };

    fetchVersions();
  }, []);

  return (
<VersionStyle>
  <Header />
  <div className="versions-shell">
    <h2 className="versions-header">{translate('versionsTitle', language)}</h2>
    <div className="versions-list">
      
      {versions.length === 0 ? (
        <div className="no-versions-message">
          <p>{translate('noUpdatesAvailable', language)}</p>
        </div>
      ) : (
        versions.map((v) => (
          <div key={v.commit} className={`version-card type-${v.type}`}>
            <div className="version-top">
              <div className="version-name">{translate('version', language)} {v.version}</div>
              <div className="version-meta">
                <div>{v.date}</div>
                <div>Commit: {v.commit}</div>
              </div>
            </div>

            <div className="version-body">{v.description}</div>
          </div>
        ))
      )}
      
    </div>
  </div>
</VersionStyle>
  );
};

export default Version;
